import Head from 'next/head'

export const DefaultHead = ({ tenantName }: { tenantName?: string }) => (
  <Head>
    <title>{[tenantName, 'Mill-Box'].compact().join(' | ')}</title>
    <link rel="icon" href="/favicon.png" />
    <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
    <link
      href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
      rel="stylesheet"
    />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
    {/* AIチャット */}
    <script
      dangerouslySetInnerHTML={{
        __html: `(function() {a=document.getElementsByTagName('script')[0];d= document.createElement('script');d.type='text/javascript';d.async=1;d.src='https://ai-chatbot.tayori.com/assets/chat/index.js?key=9f8d01dd-0f99-45fb-81fa-bc3fcc168060';a.parentNode.insertBefore(d,a)})();`,
      }}
    />
  </Head>
)
